import { render, staticRenderFns } from "./CriteriaBlock.vue?vue&type=template&id=c4e7887c&scoped=true"
import script from "./CriteriaBlock.vue?vue&type=script&lang=js"
export * from "./CriteriaBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e7887c",
  null
  
)

export default component.exports